import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { useInView } from "react-intersection-observer";
export const useScrollingPagination = t0 => {
  const $ = _c(23);
  let hasNext;
  let isLoadingNext;
  let loadNext;
  let onError;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      hasNext,
      loadNext,
      isLoadingNext,
      onError,
      rootMargin: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = hasNext;
    $[2] = isLoadingNext;
    $[3] = loadNext;
    $[4] = onError;
    $[5] = rest;
    $[6] = t1;
  } else {
    hasNext = $[1];
    isLoadingNext = $[2];
    loadNext = $[3];
    onError = $[4];
    rest = $[5];
    t1 = $[6];
  }
  const rootMargin = t1 === undefined ? "200px 0px" : t1;
  const [isLoading, setIsLoading] = useState(isLoadingNext);
  const idleCallbackRef = useRef(undefined);
  const t2 = !hasNext;
  let t3;
  if ($[7] !== rest || $[8] !== rootMargin || $[9] !== t2) {
    t3 = {
      skip: t2,
      root: typeof window !== "undefined" ? window.document : null,
      threshold: 0,
      rootMargin,
      ...rest
    };
    $[7] = rest;
    $[8] = rootMargin;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const {
    ref,
    inView
  } = useInView(t3);
  let t4;
  let t5;
  if ($[11] !== hasNext || $[12] !== inView || $[13] !== isLoading || $[14] !== loadNext || $[15] !== onError) {
    t4 = () => {
      if (inView && !isLoading && hasNext) {
        setIsLoading(true);
        Promise.resolve(loadNext()).then(() => {
          idleCallbackRef.current = requestIdleCallback(() => {
            idleCallbackRef.current = undefined;
            setIsLoading(false);
          });
        }).catch(() => {
          setIsLoading(false);
          onError?.();
        });
      }
    };
    t5 = [inView, loadNext, isLoading, hasNext, onError];
    $[11] = hasNext;
    $[12] = inView;
    $[13] = isLoading;
    $[14] = loadNext;
    $[15] = onError;
    $[16] = t4;
    $[17] = t5;
  } else {
    t4 = $[16];
    t5 = $[17];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => () => {
      if (idleCallbackRef.current) {
        cancelIdleCallback(idleCallbackRef.current);
      }
    };
    t7 = [];
    $[18] = t6;
    $[19] = t7;
  } else {
    t6 = $[18];
    t7 = $[19];
  }
  useEffect(t6, t7);
  let t8;
  if ($[20] !== isLoading || $[21] !== ref) {
    t8 = {
      ref,
      isLoading
    };
    $[20] = isLoading;
    $[21] = ref;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};